module.exports = __webpack_public_path__ + "img/400.b6b7766a.png";